import React from 'react';
import PropTypes from 'prop-types';

export default function ProfileTitle({ text, children, className }) {
    return (
        <h1 className={className}>
            {text} {children}
        </h1>
    );
}

ProfileTitle.propTypes = {
    className: PropTypes.string,
    text: PropTypes.string,
};
